module.exports = __webpack_public_path__ + "./assets/img_sanchong_color@2x__f359d77821a08637013eb98490e1e92b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_sanchong_color@2x.jpg
// module id = 621
// module chunks = 12